import { useExperimentBucket } from '@carvana/experiment';
import { NAME, CONTROL_BUCKET, VARIANT_B_BUCKET } from '../../experiments/header-copy';
import {
  Card,
  CardWrapper,
  Heading,
  HeadingWrapper,
  HeroContainer,
  SubTitle
} from './HeroFold.styles';
import VehicleEntry from './VehicleEntry';
import { headerCopy, subHeaderCopy } from './HeroFold.content';

const HeroFold = () => {
  const assignedBucket = useExperimentBucket(NAME) || CONTROL_BUCKET;
  const isLongHeader = assignedBucket === VARIANT_B_BUCKET;

  return (
    <HeroContainer>
      <HeadingWrapper>
        <Heading $isLongHeader={isLongHeader}>{headerCopy[assignedBucket]}</Heading>
        <SubTitle>{subHeaderCopy[assignedBucket]}</SubTitle>
      </HeadingWrapper>
      <CardWrapper>
        <Card>
          <VehicleEntry />
        </Card>
      </CardWrapper>
    </HeroContainer>
  );
};

export default HeroFold;
